var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 10",
    style: {
      fill: "none"
    },
    d: "M0 0h29v29H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 476",
    d: "M18 2a16 16 0 1 0 16 16A16.047 16.047 0 0 0 18 2zm6.72 22.72L16.4 19.6V10h2.4v8.32l7.2 4.32z",
    style: {
      fill: "current"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e305e5a633ee13af7f11210c67c636cd.svg";
export { ForwardRef as ReactComponent };